import { Message } from "element-ui";

/** 低于10前面加0操作
 *
 */
export function prefixPlusZero(val) {
  if (typeof val == "undefined") {
    return "";
  }
  const num = Number(val);

  if (num < 10) {
    return "0" + num;
  } else {
    return num;
  }
}
/** 根据数组对象某个属性的值筛选出符合要求的数组元素
 * @param {Array}  arr      过滤的数组
 * @param {String} attr     数组对象中的某个属性
 * @param {String} val      具体某个属性的值
 * @result {Object} 返回找到的对象元素
 *
 * */
export function arrayFind(arr, attr, val) {
  if (!(arr instanceof Array)) {
    return [];
  }
  let result = arr.find((value) => value[attr] == val);

  if (result) {
    return result;
  } else {
    return "";
  }
}

export function generateTree({ arr = [], parentId = "parentId", rootId = "0", id = "id", children = "child" } = {}, customFn) {
  arr.forEach((ele, index) => {
    // 自定义操作，如给每个数字元素添加属性
    if (customFn) {
      customFn(ele);
    }
    const parentid = ele[parentId];

    if (parentid !== rootId) {
      // 不是根数据，那么就是子元素，把ele存放到父级的child数组中
      for (let index2 = 0, len = arr.length; index2 < len; index2++) {
        const d = arr[index2];

        if (d[id] === parentid) {
          let childArray = d[children];

          if (!childArray) {
            childArray = [];
          }
          childArray.push(ele);
          d[children] = childArray;
          break;
        }
      }
    }
  });
  //去除重复元素
  return arr.filter((ele) => ele[parentId] === rootId);
}
//默认限制最近30天的内容展示
/**
 * 获取今天到之前指定天数的时间
 * @param n 几天 如：31天前，n=30
 * @returns {Array}
 */
export function getPreSevenDay(n, num) {
  if (!n) {
    n = 30;
  }
  let timeArr = [];

  let curDate = new Date();

  let arr = [];

  let dateBefore31 = new Date(curDate.getTime() - n * 24 * 60 * 60 * 1000); //31天前

  timeArr[1] = curDate.getFullYear() + "-" + getzf(Number(curDate.getMonth() + 1)) + "-" + getzf(curDate.getDate()) + " " + "23:59:59";
  timeArr[0] = dateBefore31.getFullYear() + "-" + getzf(Number(dateBefore31.getMonth() + 1)) + "-" + getzf(dateBefore31.getDate()) + " " + "00:00:00";
  return timeArr;
}
function getzf(num) {
  if (parseInt(num) < 10) {
    num = "0" + num;
  }
  return num;
}

// 生成密码动态策略规则
export function passwordParse(rules) {
  const { minLength, maxLength, includeNumber, includeLowercase, includeUppercase, includeSpecialCharacter } = rules || {};

  let lenStr = ""; // 字符位数

  let rulesObj = [];

  let reg = "";

  if (includeNumber) {
    // 数字规则
    rulesObj.push({
      info: "数字",
      reg: "(?=.*[0-9])"
    });
  }

  if (includeLowercase && includeUppercase) {
    rulesObj.push({
      info: "大小写字母",
      reg: "(?=.*[a-z])(?=.*[A-Z])"
    });
  } else if (includeLowercase) {
    rulesObj.push({
      info: "小写字母",
      reg: "(?=.*[a-z])"
    });
  } else if (includeUppercase) {
    rulesObj.push({
      info: "大写字母",
      reg: "(?=.*[A-Z])"
    });
  }

  if (includeSpecialCharacter) {
    rulesObj.push({
      info: "特殊字符",
      reg: "(?=.*[^A-Za-z0-9])"
    });
  }

  let ruleStr = rulesObj
    .reduce((pre, cur) => {
      if (cur.info) {
        reg += cur.reg;
        pre.push(cur.info);
      }
      return pre;
    }, [])
    .join("、");

  if (ruleStr) {
    ruleStr = `必须包含${ruleStr}`;
  }

  // 字符位数判断
  if (minLength == 0 && maxLength == 0) {
    lenStr = "";
  } else if (minLength == 0 && maxLength != 0) {
    lenStr = `${maxLength}位字符`;
    reg = `/^(?:${reg}).{${maxLength}}$/`;
  } else {
    lenStr = `${minLength}-${maxLength}位字符`;
    reg = `/^(?:${reg}).{${minLength},${maxLength}}$/`;
  }

  const info = [lenStr, ruleStr]
    .reduce((pre, cur) => {
      if (cur) {
        pre.push(cur);
      }
      return pre;
    }, [])
    .join("，");

  return {
    info: info,
    reg: new Function("return" + reg)()
  };
}

/** 导出文件流成功失败分别干干什么
 * @param {String} res 文件流或者JSON对象（错误情况下）
 * @param {Boolean} blob res资源是否是blob对象，文件流 默认不传递该参数
 *
 * */
export function downStreamCheck(res, blob) {
  let result = {};

  return new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.onload = (e) => {
      try {
        result = JSON.parse(e.target.result);
      } catch (e) {
        // console.log(e)
      } finally {
        if (typeof result.code !== "undefined") {
          // 返回错误对象
          Message({
            message: result.msg,
            type: "error",
            duration: 5 * 1000
          });
        } else {
          resolve();
        }
      }
    };
    if (!blob) {
      reader.readAsText(
        new Blob([res.data], {
          type: "application/octet-stream"
        })
      );
    } else {
      reader.readAsText(res.data);
    }
  });
}

/** 从响应头部读取文件名称
 * @param {res}  response
 * */
export function responseFileName(res) {
  if (res && res.headers) {
    let resultFileName = decodeURI(res.headers["content-disposition"]);

    return resultFileName.substring(resultFileName.indexOf("=")).substring(1);
  }
  return "";
}

/**
 * @param {String} resource 文件流
 * @param {String} fileType 文件类型
 * @param {String} fileName 文件名 （可以响应头部读取文件名，如下）
 *  let resultFileName = res.headers['content-disposition'];
 *  let name = resultFileName.substring(resultFileName.indexOf('=')).substring(1);
 * 使用方式 this.$downloadBlob(data,'application/octet-stream','download.zip');其中文件名可以从响应头截取
 *
 * */
export function downloadBlob(resource, fileType, fileName) {
  var data = new Blob([resource], {
    type: fileType
  });

  if ("download" in document.createElement("a")) {
    //非IE
    var downloadUrl = window.URL.createObjectURL(data);
    var anchor = document.createElement("a");

    anchor.href = downloadUrl;
    anchor.download = fileName;
    anchor.style.display = "none";
    document.body.appendChild(anchor);
    anchor.click();
    window.URL.revokeObjectURL(anchor.href);
    document.body.removeChild(anchor);
  } else {
    //IE10+下载
    navigator.msSaveBlob(data, fileName);
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js